var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaddleX(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h28v28H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 1.5,
    mask: "url(#b)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.182 5.178a11.54 11.54 0 00-5.852 8.87M7.157 24.644c3.849 2.77 9.333 2.694 13.317-.12"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)",
    stroke: "#FABB07",
    strokeWidth: 1.474
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.8,
    cy: 2.8,
    r: 2.8,
    transform: "translate(11.2 .933)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)",
    stroke: "#FABB07",
    strokeWidth: 1.474
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.8,
    cy: 2.8,
    r: 2.8,
    transform: "translate(21.467 16.8)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.475 14.212c2.77-2.126 4.432-5.498 4.432-9.197",
    stroke: "#000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#b)",
    transform: "rotate(-60 22.691 9.614)"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)",
    stroke: "#FABB07",
    strokeWidth: 1.474
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.8,
    cy: 2.8,
    r: 2.8,
    transform: "translate(.933 16.8)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaddleX);
export default __webpack_public_path__ + "static/media/PaddleX.ea6a3dff.svg";
export { ForwardRef as ReactComponent };